

























import { defineComponent, ref, onMounted } from "@vue/composition-api";
import HTMLContent from "~/components/HTMLContent.vue";

export default defineComponent({
  name: "ProductDescription",
  components: {
    HTMLContent,
  },
  props: {
    productDescription: {
      type: String,
      default: "",
      required: true,
    },
  },
  setup() {
    const descriptionElement = ref<HTMLElement | null>(null);
    const isExpanded = ref(false);
    const originalScrollPosition = ref(0);

    const toggleDescription = (): void => {
      if (!descriptionElement.value) return;
      
      if (!isExpanded.value) {
        originalScrollPosition.value = window.pageYOffset || document.documentElement.scrollTop;
        descriptionElement.value.classList.add("active");
        isExpanded.value = true;
      } else {
        descriptionElement.value.classList.remove("active");
        isExpanded.value = false;
        
        setTimeout(() => {
          window.scrollTo({
            top: originalScrollPosition.value,
            behavior: 'smooth'
          });
        }, 50);
      }
    };

    const syncStateWithDOM = (): void => {
      if (descriptionElement.value) {
        isExpanded.value = descriptionElement.value.classList.contains("active");
      }
    };

    onMounted(() => {
      syncStateWithDOM();
    });

    return { 
      descriptionElement,
      isExpanded,
      toggleDescription,
    };
  },
});
